if (!customElements.get("lookbook-section")) {
  class LookbookSection extends HTMLElement {
    constructor() {
      super();

      this.lookbookPointsWrapper = this.querySelector(
        ".lookbook-points-wrapper",
      );

      this._innerSlider = this.querySelector(
        ".lookbook-item__content slider-component",
      );

      this._swiperEventsBound = false;

      this._onSliderInit = (event) => {
        if (event.target !== this._innerSlider) return;

        this.setupSwiperEvents();
      };

      this._onFocusIn = (event) => {
        if (
          !event.target.closest(
            "[tabindex], a, button, input, textarea, select, details",
          )
        )
          return;

        this._syncOuterSwiper();

        this._syncInnerSwiper(event.target);
      };

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.lookbookActionHandler();

              this.setupSwiperEvents();

              this.observer.unobserve(this);
            }
          });
        },
        {
          rootMargin: "0px 0px -100px 0px",
        },
      );

      this.observer.observe(this);
    }

    connectedCallback() {
      this._innerSlider?.addEventListener("slider:init", this._onSliderInit);

      this.addEventListener("focusin", this._onFocusIn);

      if (this._innerSlider?.swiper) {
        this.setupSwiperEvents();
      }
    }

    disconnectedCallback() {
      this._innerSlider?.removeEventListener("slider:init", this._onSliderInit);

      this.removeEventListener("focusin", this._onFocusIn);

      this.observer?.disconnect();
    }

    getInnerSwiper() {
      return this._innerSlider?.swiper ?? null;
    }

    getOuterSwiper() {
      const section = this.closest("div.lookbook-section");

      const outerSlider = section?.querySelector(
        ".resource-list__carousel > slider-component",
      );

      return outerSlider?.swiper ?? null;
    }

    _getSlideIndex(swiper, slide) {
      if (!swiper || !slide) return -1;

      const slides = Array.from(swiper.slides).filter(
        (el) => !el.classList.contains("swiper-slide-duplicate"),
      );

      return slides.indexOf(slide);
    }

    _syncInnerSwiper(focusedEl) {
      const swiper = this.getInnerSwiper();

      const slide = focusedEl.closest(".lookbook-item__content .swiper-slide");

      if (!swiper || !slide) return;

      const index = this._getSlideIndex(swiper, slide);

      if (index >= 0 && index !== swiper.activeIndex) {
        swiper.slideTo(index, 500);
      }
    }

    _syncOuterSwiper() {
      const swiper = this.getOuterSwiper();

      const slide = this.closest(".swiper-slide");

      if (!swiper || !slide) return;

      const index = this._getSlideIndex(swiper, slide);

      if (index >= 0 && index !== swiper.activeIndex) {
        swiper.slideTo(index, 500);
      }
    }

    setupSwiperEvents() {
      const swiper = this.getInnerSwiper();

      if (!swiper || this._swiperEventsBound) return;

      this._swiperEventsBound = true;

      swiper.on("slideChange", () => {
        const targetPoint = this.lookbookPointsWrapper?.querySelector(
          `.lookbook-point[data-index="${swiper.activeIndex + 1}"]`,
        );

        if (targetPoint) {
          this.setActivePoint(targetPoint);
        }
      });
    }

    lookbookActionHandler() {
      if (this._lookbookActionsBound) return;

      this._lookbookActionsBound = true;

      this.lookbookPoints = this.querySelectorAll(".lookbook-point");

      this.lookbookPoints.forEach((point) => {
        point.addEventListener("click", () => {
          this.lookbookPointActive(point);
        });

        point.addEventListener("mouseenter", () => {
          this.lookbookPointActive(point);
        });

        const focusTarget = point.querySelector(".point-circle");

        focusTarget?.addEventListener("focus", () => {
          this.lookbookPointActive(point);
        });
      });
    }

    setActivePoint(point) {
      if (!point || point.classList.contains("active")) return;

      this.lookbookPointsWrapper
        ?.querySelector(".lookbook-point.active")
        ?.classList.remove("active");

      point.classList.add("active");
    }

    lookbookPointActive(point) {
      const targetIndex = parseInt(point.dataset.index, 10) - 1;

      const swiper = this.getInnerSwiper();

      const wasActive = point.classList.contains("active");

      this.setActivePoint(point);

      if (!wasActive && swiper) {
        swiper.slideTo(targetIndex, 1000);
      }
    }
  }

  customElements.define("lookbook-section", LookbookSection);
}
